export default __webpack_public_path__ + "static/media/website.78632488.svg";